export default "__VITE_ASSET__rQ023pfU__"